import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-medium" }, "確認コード")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "w-full"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-10 w-full text-xl font-semibold text-red-600"
}
const _hoisted_5 = ["loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCode && _ctx.handleCode(...args)), ["prevent"])),
      class: "mt-5 w-full space-y-5"
    }, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationCode) = $event)),
          type: "tel",
          maxlength: "6",
          class: "h-12 w-64 rounded border border-gray-800 px-5"
        }, null, 512), [
          [_vModelText, _ctx.verificationCode]
        ])
      ]),
      (_ctx.hasErrorVerificationCode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsVerificationCode, (error, k) => {
              return (_openBlock(), _createElementBlock("span", { key: k }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.sendFail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        loading: _ctx.isLoading,
        class: "w-64 rounded-md bg-sky-400 py-3 text-center text-2xl font-semibold font-semibold text-black hover:bg-sky-500 hover:text-white"
      }, _toDisplayString(_ctx.isLoading ? "送信中..." : "送信"), 9, _hoisted_5)
    ], 32)
  ]))
}